import { Container, Digit } from './Gauge.style';
import calcDashOffset from '../../utils/calcDashOffset';
import { calcPercentage, calcDynamicIncrement } from '../../utils/math';
import { useEffect, useMemo, useRef, useState } from 'react';
import { animation } from '../../utils/animation';

const ANIMATION_TIME = 2000;

const Gauge = ({ value, maxValue, text, midText, children }) => {
  const percent = calcPercentage(value, maxValue);
  const offset = calcDashOffset(percent);

  return (
    <Container offset={offset} animationTime={ANIMATION_TIME}>
      <svg
        role='meter'
        aria-label='Statistics Gauge'
        aria-labelledby={(text + ' ' + midText).toLowerCase()}
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        viewBox='40 10 100 90'
      >
        <path
          className='grey'
          d='M 60 95 A 45 45 90 1 1 120 95'
          style={{ fill: 'none' }}
        />
        <path
          className='blue'
          d='M 60 95 A 45 45 90 1 1 120 95'
          style={{ fill: 'none' }}
        />
        <text dominantBaseline='middle' x='50%' y='55%'>
          <tspan x='90%' dy='-5%'>
            {text}
          </tspan>
          <tspan x='90%' dy='10.5%'>
            {midText}
          </tspan>
          {children}
        </text>
      </svg>
    </Container>
  );
};

const Value = ({ value, suffix = '%' }) => {
  const [count, setCount] = useState(0);

  const dynamicIncrement = useMemo(() => calcDynamicIncrement(value), [value]);

  const animate = useRef(
    animation(() => {
      setCount((prev) => {
        const next = Math.ceil(prev + dynamicIncrement);

        return next > value ? value : next;
      });
    }, ANIMATION_TIME / value)
  );

  useEffect(() => {
    if (!animate.current.isRunning() && count < value) {
      animate.current.start();
    }

    if (count >= value) {
      animate.current.stop();
    }
  }, [count, animate, value]);

  return (
    <Digit x='90%' dy='20.5%'>
      {`${count}${suffix}`}
    </Digit>
  );
};

Gauge.Value = Value;

export default Gauge;
